import { useEffect, useRef } from "react";
import { useSession, signOut } from "next-auth/react";
import { useRouter } from "next/router";
import { useNotify } from "@/hooks/useNotify";


const PUBLIC_PATHS = new Set([
  "/signin",
  "/signup",
  "/login-confirm",
  "/reset-password",
  "/confirm-password",
  "/verify-password",
  "/sessionExpired",
  "/terms-and-conditions",
  "/privacy",
]);


const SessionErrorWatcher = () => {
  const { data: session, status } = useSession();
  const router = useRouter();
  const notify = useNotify();
  const wasAuthenticated = useRef(false);

  useEffect(() => {
    if (status === "authenticated") {
      wasAuthenticated.current = true;
    }
  }, [status]);

  useEffect(() => {
    const refreshFailed = session?.error === "RefreshAccessTokenError";
    // Set by the jwt callback when the profile endpoint rejects the access
    // token with 401 - happens when the account was disabled/deleted after
    // the user already had an active session.
    const userUnauthorized = session?.error === "UserUnauthorizedError";
    const sessionExpired =
      status === "unauthenticated" &&
      wasAuthenticated.current &&
      !PUBLIC_PATHS.has(router.pathname);

    if (!refreshFailed && !userUnauthorized && !sessionExpired) return;

    wasAuthenticated.current = false;
    if (userUnauthorized) {
      notify(
        "info",
        "Signed out",
        "Your account is no longer active, so you've been signed out.",
      );
    }
    signOut({ redirect: false }).then(() => {
      router.replace("/signin");
    });
  }, [session?.error, status, router.pathname, notify]);

  return null;
};

export default SessionErrorWatcher;
